module.exports = __webpack_public_path__ + "static/media/ia.cd9af437.png";